'use client';

import { AuthShell } from '~/entities/AuthShell';
import { SignInForm } from '~/features/SignInForm';
import { TelegramSignInButton } from '~/features/TelegramSignInButton';

export default () => {
    return (
        <AuthShell
            header={<h1 className='w-full py-4 text-center font-semibold text-lg text-neutral-500 uppercase'>Вход</h1>}
            className='max-w-[25rem]'
        >
            <div className='flex flex-col items-center gap-3'>
                <SignInForm />

                <div className={'flex w-full items-center gap-x-page'}>
                    <div className={'h-0.5 flex-1 bg-neutral-300'} />
                    <span className={'font-600 text-14 text-neutral-400 uppercase'}>Или</span>
                    <div className={'h-0.5 flex-1 bg-neutral-300'} />
                </div>

                <TelegramSignInButton />
            </div>
        </AuthShell>
    );
};
